import type { CommentResponse } from '@/api/types/Comment'
import { useGetUser } from '@/api/user'
import Avatar from '@/elements/Avatar'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Timestamp from '@/elements/Timestamp'

const AlertComment = ({
  comment
}: {
  comment: CommentResponse
}) => {
  const activityCreatorId = typeof comment.user === 'string'
    ? comment.user
    : comment.user?.id || undefined
  const { data: activityCreatorData } = useGetUser(activityCreatorId)
  const activityCreator = activityCreatorData?.data?.user

  return (
    <Flex wfull inline gap={2}>
      <Avatar
        name={activityCreator?.details.fullName}
        size='small'
        src={activityCreator?.assets?.PROFILE_PICTURE || ''}
      />
      <Flex wfull gap={1}>
        <Timestamp from={comment.createdAt ?? ''} noIcon />
        <Text variant='textblock' color='black-light-20'>
          <b>{activityCreator?.details.fullName || 'undefined user'}</b> added a comment:
        </Text>
        <Flex wfull color='gray-light-60' p={3} radius='small'>
          <Text variant='textblock' style={{ whiteSpace: 'pre-wrap' }}>
            {comment.content}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default AlertComment
